'use client'
import { IHub } from '@core/auth/hooks/use-get-hubs-list/use-get-hubs-list.hook.types'
import { hermesLogger } from '@core/observability'
import { unleashClient } from '@core/unleash/unleash-client'
import { useRef } from 'react'

export const useStartUnleash = () => {
  const unleashClientStarted = useRef(false)

  async function startUnleashSdk(hubSelected?: IHub) {
    const hubAlias = hubSelected?.alias

    if (hubAlias) {
      await unleashClient
        .updateContext({
          properties: {
            hubAlias: hubAlias,
          },
        })
        .then(() => {
          if (!unleashClientStarted.current) {
            unleashClient.start().catch((error) => {
              hermesLogger.error('[Unleash] Can not start Unleash', error)
            })
            unleashClientStarted.current = true
          }
        })
        .catch((error) => {
          hermesLogger.error('[Unleash] Can not connect to Unleash', error)
        })
    }
  }

  return startUnleashSdk
}
